import { useCallback } from "react";
import { useGeotabClient } from "@/components/GeotabClientContext";
import AddInIds from "@/constants/AddInIds";
import { useUpdateAddIn } from "@/hooks/addins/useUpdateAddIn";
import { DiagnosticView } from "@/models/DiagnosticView";

export function useSaveView() {
  const updateAddIn = useUpdateAddIn<DiagnosticView>(AddInIds.diagnosticViews, "id");
  const { username } = useGeotabClient();

  const saveView = useCallback(
    async (view: DiagnosticView) => {
      const next: DiagnosticView = {
        ...view,
        updatedAt: Date.now(),
        updatedBy: username,
      };
      return updateAddIn.mutateAsync(next);
    },
    [updateAddIn, username],
  );

  return { saveView, isPending: updateAddIn.isPending };
}
